$(document).ready(function () {

    function initMobileSlick() {
      if ($(window).width() < 768) {

        // Initialize only if not already initialized
        if (!$('.oi-card-list-slider').hasClass('slick-initialized')) {
          $('.oi-card-list-slider').slick({
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '25px', // Reduce side gap on mobile
            variableWidth: true,
          });
        }
      } else {
        // Destroy slick on desktop
        if ($('.oi-card-list-slider').hasClass('slick-initialized')) {
          $('.oi-card-list-slider').slick('unslick');
        }

      }
    }
    // Initial check
    initMobileSlick();

    // Re-check on resize
    $(window).on('resize', function () {
      initMobileSlick();
    });

  });